import "./Contact.module.css";
import Header from "@/reusable_sections/Header";
import ContactDetails from "./sections/ContactDetails";
import InquiryForm from "./sections/InquiryForm";
import Footer from "@/reusable_sections/Footer";
export default function ContactPage() {
  return <div>
      <Header />
      <ContactDetails />
      <InquiryForm />
      <Footer />
    </div>;
}